
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Eye, Ruler, Factory } from "lucide-react";
import { ParsedColorInfo } from "@/hooks/color-check/types";

interface ProductAnalysisSectionProps {
  parsedInfo: ParsedColorInfo;
}

const ProductAnalysisSection = ({ parsedInfo }: ProductAnalysisSectionProps) => {
  return (
    <div>
      <h4 className="font-medium text-sm mb-2 flex items-center">
        <Eye className="mr-1 h-4 w-4 text-purple-500" />
        Exacte Product & Maat Analyse
      </h4>
      <div className="grid grid-cols-2 gap-2 text-sm">
        {parsedInfo.productName && (
          <div>
            <span className="text-muted-foreground">Product:</span>
            <p className="font-medium">{parsedInfo.productName}</p>
          </div>
        )}
        {parsedInfo.size && (
          <div>
            <span className="text-muted-foreground">Gevraagde Maat:</span>
            <p className="font-medium flex items-center">
              <Ruler className="mr-1 h-3 w-3 text-blue-500" />
              {parsedInfo.size}
              {parsedInfo.sizeCode && (
                <Badge variant="outline" className="ml-1 text-xs">
                  Code: {parsedInfo.sizeCode}
                </Badge>
              )}
            </p>
          </div>
        )}
        {parsedInfo.colorCode && (
          <div>
            <span className="text-muted-foreground">Kleurcode:</span>
            <p className="font-medium">{parsedInfo.colorCode}</p>
          </div>
        )}
        {parsedInfo.brand && (
          <div>
            <span className="text-muted-foreground">Merk:</span>
            <p className="font-medium flex items-center">
              <Factory className="mr-1 h-3 w-3" />
              {parsedInfo.brand}
            </p>
          </div>
        )}
        {parsedInfo.variantInfo && (
          <div className="col-span-2">
            <span className="text-muted-foreground">Variant info:</span>
            <Badge variant="outline" className="ml-1 text-xs bg-yellow-50">
              {parsedInfo.variantInfo}
            </Badge>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductAnalysisSection;
